import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState } from "../../utils/api/user/user.type";
import { AppStorage } from "../../utils/storage";

/* eslint-disable @typescript-eslint/no-explicit-any */
const normalizeUser = (userData: any): any => {
	if (!userData) return null;
	let user = userData;
	while (user && user.data && typeof user.data === "object" && !user.id && !user.email) {
		user = user.data;
	}
	if (user && user.user && typeof user.user === "object" && !user.id && !user.email) {
		user = user.user;
	}
	return user;
};

const getInitialState = (): AuthState => {
	const stored = AppStorage.getItem<any>("user", null);
	if (!stored) {
		return { user: null, token: null };
	}
	let user = null;
	let token = null;

	if (typeof stored === "object") {
		if ("user" in stored) {
			user = normalizeUser(stored.user);
			token = stored.token || AppStorage.getItem<any>("token", null);
		} else if (stored.id || stored.email) {
			user = normalizeUser(stored);
			token = AppStorage.getItem<any>("token", null);
		}
	}
	return { user, token };
};

const initialState: AuthState = getInitialState();

export const UserSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		onSetUser: (state, action: PayloadAction<AuthState["user"]>) => {
			const newUserData = normalizeUser(action.payload);
			const currentUserData = normalizeUser(state.user);
			state.user = currentUserData ? { ...currentUserData, ...newUserData } : newUserData;
			AppStorage.setItem("user", { user: state.user, token: state.token });
		},
		onSetToken: (state, action: PayloadAction<AuthState["token"]>) => {
			state.token = action.payload;
			AppStorage.setItem("user", { user: state.user, token: state.token });
		},
		onSetUserToken: (state, action: PayloadAction<AuthState>) => {
			state.user = normalizeUser(action.payload?.user);
			state.token = action.payload?.token || state.token || null;
			AppStorage.setItem("user", { user: state.user, token: state.token });
		},
		onlogout: (state) => {
			state.user = null;
			state.token = null;
			AppStorage.setItem("user", { user: null, token: null });
			AppStorage.clear();
			window.location.pathname = "/connexion";
		},
	},
});

export const { onSetUser, onSetUserToken, onSetToken, onlogout } = UserSlice.actions;
export default UserSlice.reducer;
